import moment from "moment";
import axios from "axios";

export default class GisApi {
    appSettings;
    constructor(appSettings) {
        this.appSettings = appSettings || {
            gisUrl: "https://gis.piramislocator.com",
            gisWs: "wss://gis.piramislocator.com",
            gisToken: "mVfTg5SGPgakPqk8ApIDsmEqZ061D63i",
            lastPositionInterval: 30,
            lastEventInterval: 5,
            lastCommandInterval: 5,
            infocarUser: "DAT-pieEBK",
            infocarPassword: "HorseStaple1!"
        };
    }

    login = async () => {
        const authRequest = await fetch(
            `${this.appSettings.gisUrl}/api/session?token=${this.appSettings.gisToken}`,
            {
                credentials: "include"
            }
        );

        if (authRequest.ok) {
            return await authRequest.json();
        } else {
            return false;
        }
    };

    getDevice = async imei => {
        let device = ``;
        if (imei) {
            device = `?uniqueId=${imei}`
        }
        const deviceRequest = await fetch(
            `${this.appSettings.gisUrl}/api/devices${device}`,
            {
                credentials: "include"
            }
        );
        if (deviceRequest.ok) {
            const devices = await deviceRequest.json();
            return devices.length ? imei ? devices[0] : devices : false;
        } else {
            return false;
        }
    };

    getLastPosition = async id => {
        const to = moment().toJSON();
        let from = "";
        if (process.env.LOCALDEV) {
            from = moment()
                .subtract(2, "day")
                .toJSON();
        } else {
            from = moment()
                .subtract(this.appSettings.lastPositionInterval, "minutes")
                .toJSON();
        }

        const positionsRequest = await fetch(
            `${this.appSettings.gisUrl}/api/positions?deviceId=${id}&from=${from}&to=${to}`,
            {
                credentials: "include"
            }
        );
        if (positionsRequest.ok) {
            const positions = await positionsRequest.json();
            const valid = positions.filter(el => el.attributes.sat);
            return valid.length ? valid[valid.length - 1] : false;
        } else {
            return false;
        }
    };

    getLastEvent = async id => {
        const to = moment().toJSON();
        let from = "";
        if (process.env.LOCALDEV) {
            from = moment()
                .subtract(2, "day")
                .toJSON();
        } else {
            from = moment()
                .subtract(this.appSettings.lastEventInterval, "minutes")
                .toJSON();
        }

        const eventsRequest = await fetch(
            `${this.appSettings.gisUrl}/api/reports/events?deviceId=${id}&from=${from}&to=${to}`,
            {
                credentials: "include"
            }
        );
        if (eventsRequest.ok) {
            const events = await eventsRequest.json();
            const valid = events.filter(el => el.attributes.result);
            return valid.length ? valid[valid.length - 1] : false;
        } else {
            return false;
        }
    };

    getLastCommandResult = async id => {
        const to = moment().toJSON();
        let from = "";
        if (process.env.LOCALDEV) {
            from = moment()
                .subtract(1, "hour")
                .toJSON();
        } else {
            from = moment()
                .subtract(this.appSettings.lastCommandInterval, "minutes")
                .toJSON();
        }

        const commandsRequest = await fetch(
            `${this.appSettings.gisUrl}/api/reports/events?deviceId=${id}&from=${from}&to=${to}`,
            {
                credentials: "include"
            }
        );
        if (commandsRequest.ok) {
            const commands = await commandsRequest.json();
            const valid = commands.filter(el => el.type=="commandResult");
            return valid.length ? valid[valid.length - 1] : false;
        } else {
            return false;
        }
    };

    createDevice = async (imei, phone, name, category) => {
        const data = {
            groupId: 0,
            name,
            uniqueId: imei,
            geofenceIds: [],
            phone,
            model: "vehicle",
            contact: "",
            category,
            disabled: false
        };

        const createResp = await fetch(`${this.appSettings.gisUrl}/api/devices`, {
            method: "post",
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });

        if (createResp.ok) {
            return await createResp.json();
        } else {
            return false;
        }
    };

    deleteDevice = async id => {
        const deleteResp = await fetch(
            `${this.appSettings.gisUrl}/api/devices/${id}`,
            {
                method: "delete",
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            }
        );

        if (deleteResp.ok) {
            return true;
        } else {
            return false;
        }
    };

    updateAccumulators = async (id, km, hours) => {
        const data = {
            deviceId: id,
            totalDistance: km,
            hours: hours
        };
        const accumulatorsResp = await fetch(
            `${this.appSettings.gisUrl}/api/devices/${id}/accumulators`,
            {
                method: "put",
                body: JSON.stringify(data),
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            }
        );

        if (accumulatorsResp.ok) {
            return true;
        } else {
            return false;
        }
    };

    sendComand = async (deviceId, data, description, textChannel = false) => {
        const command = {
            attributes: {
                data
            },
            deviceId,
            type: "custom",
            textChannel,
            description
        };

        const commandResp = await fetch(
            `${this.appSettings.gisUrl}/api/commands/send`,
            {
                method: "post",
                body: JSON.stringify(command),
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            }
        );

        if (commandResp.ok) {
            return await commandResp.json();
        } else {
            return false;
        }
    };

    setDevice = async (deviceNumber, timeout) => {
        try {
            await axios.get(`/api/smsGateway/${deviceNumber}/p l getrecord`);
            await axios.get(
                `/api/smsGateway/${deviceNumber}/p l setparam 1000:${timeout}`
            );
            return true;
        } catch {
            return false;
        }
    };

    smsCommand = async (deviceNumber, command) => {
        await axios.get(`/api/smsGateway/${deviceNumber}/${command}`);
        return true;
    };
}
